import { makeStyles } from '@material-ui/core/styles';
import { useIsFieldRequired } from './ProductValidationContext';
import { ProductRuleFieldType } from './type';

const useStyles = makeStyles(theme => ({
  asterisk: {
    color: theme.palette.error.main,
  },
}));

/** Same asterisk as InputLabel, for headings that are not rendered through InputLabel. */
const RequiredAsterisk = ({ field }: { field: ProductRuleFieldType }) => {
  const classes = useStyles();
  const isRequired = useIsFieldRequired(field);
  if (!isRequired) return null;
  return <span className={classes.asterisk}> *</span>;
};

export default RequiredAsterisk;
